import { Form } from 'tabler-react'

import { FormCard } from '../Form'

const SavePasswordForm = ({
  errors,
  values,
  handleChange,
  handleSubmit,
  isSubmitting
}) => (
  <FormCard
      buttonText='Submit'
      title='Set Password to create your profile'
      onSubmit={handleSubmit}
      action={null}
      method={null}
      loading={isSubmitting}
    >
      <Form.Group label='Email'>
        <Form.Input
          name='email'
          type='email'
          disabled
          value={values.email}
          error={errors && errors.email}
          onChange={handleChange}
          placeholder='Email'
        />
      </Form.Group>
      <Form.Group label='Password'>
        <Form.Input
          name='password'
          type='password'
          autocomplete={false}
          value={values.password}
          error={errors && errors.password}
          onChange={handleChange}
          placeholder='Password'
        />
      </Form.Group>
  </FormCard >
)

export default SavePasswordForm